<template>
  <Transition :name="transitionName">
    <div
      v-if="isModalOpen" class="modal_panel"
      :class="{license_panel : showModal.isLicense}"
    >
      <button
        type="button" class="modal_panel_close"
        @click="closeModal"
      >
        <img src="@/assets/images/Icons/Close.png" alt="close">
      </button>
      <h6>
        <img src="@/assets/images/Icons/ForgotError.png" alt="forgot_error icon" />
        <span>
          {{ errorTitle }}
        </span>
      </h6>
      <img
        v-if="isErrorMeteIcon"
        class="error_mete" :class="{forgotModal : showModal.isForgotAccount}"
        src="@/assets/images/ErrorMete.png"
        alt="ERROR-메테"
      >
      <img
        v-if="isLicenceMeteIcon"
        class="license_mete" src="@/assets/images/Mete/Mete.png"
        alt="License-메테"
      >
      <div
        class="modal_description"
        :class="{ successModal : !isErrorMeteIcon, forgotModal : showModal.isForgotAccount }"
      >
        <slot name="contentDescription" />
      </div>
      <slot name="contact" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import useCommonStore from '@/store/storeCommon';

const { showModal, closeModal } = useCommonStore();

defineProps<{
  transitionName: string;
  isModalOpen: boolean | undefined;
  errorTitle: string | undefined;
  isErrorMeteIcon?: boolean;
  isLicenceMeteIcon?: boolean;
}>();
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.modal_panel {
  background: url("@/assets/images/ForgetBox.png") no-repeat center;
  background-size: contain;
  width: 233px;
  height: 282px;
  color: $color-white;
  font-family: "Pretendard Regular 400", sans-serif;
  padding: 47px 26px 28px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
  pointer-events: auto;

  &_close {
    width: 10.6px;
    position: absolute;
    top: 18px;
    right: 10.4px;

    img {
      width: 100%;
    }
  }

  h6 {
    font-family: "Pretendard SemiBold 600", sans-serif;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid $color-debra;
    padding-bottom: 6.2px;

    img {
      width: 17px;
    }

    span {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }

  .error_mete {
    width: 84px;
    margin: 13.8px auto 40px;
    display: flex;

    &.forgotModal {
      margin: 13.8px auto 9.3px;
    }
  }

  > .modal_description {
    font-size: 0.87rem;
    line-height: 1.33;
    padding-bottom: 6px;
    text-align: center;

    &.successModal {
      height: 200px;
      padding-bottom: 6px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &.forgotModal {
      font-size: 12px;
    }
  }

  &.license_panel {
    width: 350px;
    height: 424px;
    padding: 47px 25px 28px;

    .modal_panel_close {
      top: 23px;
      pointer-events: auto;
    }

    .license_mete {
      width: 84px;
      margin: 13.8px auto 20px;
      display: flex;
    }

    .successModal {
      font-size: 12px;
      line-height: 1.33;
      padding-bottom: 6px;
      text-align: left;
      display: inherit;
      height: auto;
    }

    &.fade-enter-active,
    &.fade-leave-active {
      transition: opacity 0.5s ease !important;
    }
  }
}

@media screen and (max-width: 350px) {
  .license_panel {
    width: 95%;
    background-image: none;
    background-color: rgba(0, 0, 0, 0.5);
    border: 3px solid $color-debra;
    border-radius: 10px;
    overflow: auto;
    overflow-x: hidden;
    padding-top: 28px;
  }
}

@media screen and (max-height: 424px) {
  .license_panel {
    height: 95dvh;
    background-image: none;
    background-color: rgba(0, 0, 0, 0.5);
    border: 3px solid $color-debra;
    border-radius: 10px;
    overflow: auto;
    overflow-x: hidden;
  }
}
</style>